import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const MultiDigitalRetailOfferTypeAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "multi-digital-retail-offer-type" */ './multi-digital-retail-offer-type'),
  componentName: 'MultiDigitalRetailOfferType',
});
